import { notification } from '../components/Notifications'
interface ExportCsvOptions {
  data: string
  fileName?: string | undefined
  message?: string
  headers?: any
}
export const exportCsv = ({ data, fileName, message = 'CSV successfully downloaded', headers }: ExportCsvOptions): void => {
  const contentDisposition = headers?.['content-disposition'] ?? headers?.contentDisposition
  const headerFileName = contentDisposition?.match(/filename="?(.*?)"?$/)?.[1] ?? 'Export.csv'
  const exportedFileName = fileName ?? headerFileName
  const blob = new Blob([data], { type: 'text/csv;charset=utf-8;' })
  const url = URL.createObjectURL(blob)
  const link = document.createElement('a')
  link.href = url
  link.setAttribute('download', exportedFileName)
  document.body.appendChild(link)
  link.click()
  document.body.removeChild(link)
  URL.revokeObjectURL(url)
  notification(message, { variant: 'success', subTitle: exportedFileName })
}
